var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabledDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.75L8.25 11.25M8.25 6.75L12.75 11.25M2.04 9.72L5.28 14.04C5.544 14.392 5.676 14.568 5.84329 14.6949C5.99145 14.8074 6.15924 14.8913 6.33808 14.9423C6.54 15 6.76 15 7.2 15H12.9C14.1601 15 14.7902 15 15.2715 14.7548C15.6948 14.539 16.039 14.1948 16.2548 13.7715C16.5 13.2902 16.5 12.6601 16.5 11.4V6.6C16.5 5.33988 16.5 4.70982 16.2548 4.22852C16.039 3.80516 15.6948 3.46095 15.2715 3.24524C14.7902 3 14.1601 3 12.9 3H7.2C6.76 3 6.54 3 6.33808 3.05767C6.15924 3.10874 5.99145 3.19264 5.84329 3.30506C5.676 3.432 5.544 3.608 5.28 3.96L2.04 8.28C1.84635 8.53819 1.74953 8.66729 1.71221 8.80907C1.67926 8.93423 1.67926 9.06577 1.71221 9.19093C1.74953 9.33271 1.84635 9.46181 2.04 9.72Z",
    stroke: "#98A2B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledDelete);
export default __webpack_public_path__ + "static/media/disabled-delete.2886f3e88e9fcf1cbc266196d8bf032a.svg";
export { ForwardRef as ReactComponent };